import { render, staticRenderFns } from "./ListaDistribucionPantalla.vue?vue&type=template&id=330746fa&"
import script from "./ListaDistribucionPantalla.vue?vue&type=script&lang=ts&"
export * from "./ListaDistribucionPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports